<button
  nimbusPrimaryIconButton
  cdkOverlayOrigin
  #origin="cdkOverlayOrigin"
  [disabled]="disabled || !filterOptions?.length"
  id="remove"
  class="icon-button"
  [attr.aria-label]="TranslationKeys.GeneralFilter | translate"
  (click)="onTriggerClick($event)"
>
  <i [nimbusIcon]="ICONS.FILTER_LIST"></i>
  <nimbus-tooltip [text]="TranslationKeys.GeneralFilter | translate"></nimbus-tooltip>
</button>

<ng-template
  cdkConnectedOverlay
  cdkConnectedOverlayPanelClass="nimbus-filter-overlay"
  [cdkConnectedOverlayHasBackdrop]="false"
  [cdkConnectedOverlayOrigin]="origin"
  [cdkConnectedOverlayPositions]="cdkConnectedPositions"
  [cdkConnectedOverlayOpen]="isOpen"
  (overlayOutsideClick)="onOutsideClick($event)"
>
  <div class="nimbus-filter-overlay-content" (click)="$event.stopPropagation()">
    @for (option of filterOptions; track trackByFn($index, option)) {
      <div
        class="nimbus-filter-overlay-option"
        tabindex="0"
        role="button"
        (click)="handleOptionBackgroundClick($event, option)"
        (keydown.enter)="onOptionSelected(option, true); $event.stopPropagation()"
        (keydown.space)="onOptionSelected(option, true); $event.preventDefault(); $event.stopPropagation()"
      >
        <nimbus-input-slide-toggle
          class="nimbus-filter-toggle"
          [stopPropagation]="true"
          [isSmall]="true"
          [value]="isOptionSelected(option)"
          (changeValue)="onOptionSelected(option, true)"
        ></nimbus-input-slide-toggle>
        <div class="nimbus-filter-divider"></div>
        <button class="nimbus-filter-name" (click)="onOptionSelected(option, false, $event)">
          {{ option.name | translate }}
        </button>
        @for (item of option.icons; track item) {
          <span class="icon tooltip-container">
            <i [nimbusIcon]="item.icon" [class.disabled]="item.isDisabled"></i>
            @if (item.tooltip) {
              <nimbus-tooltip [text]="item.tooltip | translate"></nimbus-tooltip>
            }
          </span>
        }
      </div>
    }
  </div>
</ng-template>
